<template>
  <div>
    <content-editor
      permission="branch"
      :fields="fields"
      :endpoint="`structure/${$route.params.structure}/node`"
      :contentOptional="true"
      :canDelete="false"
      :canLock="false"
      :module="'structure'">
    </content-editor>
  </div>
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import getString from '@/helpers/GetStrings';

export default {
  data() {
    return {
      fields: [
        {
          name: 'name',
          required: false,
          readOnly: true,
        },
        {
          name: 'cover',
          required: true,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
  methods: {
    getString,
  },
};
</script>
